<template>
    <div>
        <Card>
            <p slot="title">
                Hapus Pembayaran
            </p>

            <Row type="flex" justify="space-between" class="code-row-bg">
                <Col span="6">
                    <Select

                        placeholder="Ketik Marking"
                        v-model="markingIdSelected"
                        filterable
                        clearable
                        remote
                        :remote-method="getMarkingByCode"
                        :loading="loadingGetMarking"
                        @on-change="getPayment"
                        >
                        <Option v-for="(option, index) in optionMarkings"
                            :value="option.value" :key="index">{{option.label}}</Option>
                    </Select>

                </Col>
                <Col span="6">

                </Col>
                <Col span="6">
                </Col>
            </Row>

            <br>
            <Table
                v-show="payments.length > 0"
                :columns="tableColumns"
                :data="payments"
                no-data-text=""
                @on-row-click=""
                @on-selection-change="onSelectionChange"
            ></Table>
            <br/><br/>
            <Modal v-model="modalConfirmMultipleDelete" width="500px">
                <p slot="header" style="color:#f60;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Konfirmasi</span>
                </p>
                <div style="text-align:left">
                    <div v-for="paymentToDelete in paymentsToDelete">
                        <strong>{{ paymentToDelete.paymentDate }} </strong> <Tag color="blue">Rp {{ paymentToDelete.amount | numberFormatted }}</Tag>
                        <br/>{{ paymentToDelete.description }}
                        <br/><br/>
                    </div>

                    Total Pembayaran  <Tag color="green">Rp {{ totalPaymentToDelete | numberFormatted }}</Tag>
                </div>
                <div slot="footer">
                    <Button
                        type="error" size="large" long :loading="isLoadingDelete"
                        @click="deletePayments(paymentsToDelete)"
                        >Hapus</Button>
                </div>
            </Modal>
        </Card>
        <div class="footer" v-show="paymentsToDelete.length > 0">
            <Button
                type="error"
                :loading="isLoadingDelete"
                @click="modalConfirmMultipleDelete = true"
                icon="trash-a"
                size="small"  >
                    <span>Hapus {{ paymentsToDelete.length }} data</span>
            </Button>
        </div>
    </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'

const numeral = require('numeral');
const axios = require('axios');

export default {
    data: () => ({
        modalConfirmMultipleDelete: false,
        markingIdSelected : '',
        optionMarkings : [],
        loadingGetMarking: false,
        loadingSearch : false,
        payments : [],
        paymentsToDelete: [],
        isLoadingDelete: false,
        totalPaymentToDelete: 0,
        userRole: localStorage.getItem('user.role'),
        subbranchcode: localStorage.getItem('user.subbranchcode'),
        tableColumns: [
            {
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {
                title: 'Tgl',
                key: 'paymentDate',
                width: 150,
                sortable: false
            },
            {
                title: 'Marking',
                key: 'markingheadercode',
                width: 200,
                sortable: false
            },
            {
                title: 'Keterangan',
                key: 'description',
                sortable: false
            },
            {
                title: 'Jumlah',
                align : 'right',
                key: 'creditAmount',
                width: 150,
                sortable: false
            }
        ],
        filterInput : ''

    }),
    //components : {HeaderTable},
    methods: {
        getPayment: function(){
            let urlGet = 'payment/show';

            this.payments = []
            this.paymentsToDelete = []

            if(this.markingIdSelected !== ''){
                urlGet += '/' + this.markingIdSelected;
            } else {
                return false;
            }

            this.loadingSearch = true;

            HTTP
            .get(urlGet)
            .then(response => {
                let parent = this;

                let payments = []
                _.forEach(response.data, function(value) {
                    let isDisabled = false;

                    if(parent.userRole != 'ADMINISTRATOR' && value.category === 'disc') {
                        isDisabled = true;
                    }

                    let payment = {
                        paymentId : value.id,
                        receivableId : value.receivable.id,
                        paymentDate : parent.showDateFormatted(value.paymentDate),
                        markingHeaderId : value.markingHeaderId,
                        markingheadercode : value.receivable.marking_minified.markingheadercode,
                        description : value.receivable.description,
                        amount : value.receivable.creditAmount,
                        creditAmount : numeral(value.receivable.creditAmount).format('0,0'),
                        category : value.receivable.category,          // tambahkan ini
                        // _disabled : isDisabled
                    }

                    payments.push(payment);
                });
                this.payments =  payments;
                this.loadingSearch = false;


                if(payments.length == 0) {
                    this.$Notice.error({
                        title: '',
                        desc: 'Pembayaran tidak ditemukan',
                        duration: 3
                    });
                }
            })
            .catch(e => {
                this.loadingSearch = false;
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
        getMarkingByCode: _.debounce(
            function (query) {

                if (query !== '') {
                    this.loadingGetMarking = true;
                    HTTP
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query,
                        subbranchcode: this.subbranchcode
                    })
                    .then(response => {

                        this.invoiceDues = []
                        this.amountResidue = ''
                        this.amountReceived = ''
                        this.description = ''

                        this.loadingGetMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.markingheaderid,
                                label: item.markingheadercode
                            };
                        });

                        this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.loadingGetMarking = false;
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 400
        ),
        showDateFormatted : function(stringToFormat){
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        deletePayments: function(paymentsToDelete) {

            this.isLoadingDelete = true
            let promises = [];
            let parent = this;
            paymentsToDelete.forEach(function(paymentToDelete){
                promises.push(
                    HTTP
                    .post('payment/delete', {
                        paymentId: paymentToDelete.paymentId,
                        receivableId: paymentToDelete.receivableId
                    })
                    .then(response => {
                        return response
                    })
                    .catch(e => {
                        throw new Error(e.response.data.message)
                    })
                )
            });

            axios.all(promises)
            .then(function(results) {

                parent.paymentsToDelete = []
                parent.$Message.success({
                    content: 'Data Terhapus',
                    duration: 2
                });
                parent.getPayment();
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
            .finally( e => {
                this.isLoadingDelete = false
                this.modalConfirmMultipleDelete = false;
            });
        },
        onSelectionChange:function(selection){
            this.paymentsToDelete = selection.filter(item => item.category !== 'disc')
            this.totalPaymentToDelete = _.sumBy(this.paymentsToDelete, 'amount')
        }
    },

  created() {
    // this.getReceivable();
  }
}
</script>



// WEBPACK FOOTER //
// PaymentDelete.vue?3e6eb1f3